"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    container: {
      padding: 0,
      textAlign: "center",
      height: "100%",
      width: "100%",
      maxWidth: "100%",
      backfaceVisibility: "hidden",
      backgroundSize: "auto 80%",
      backgroundPosition: "50% 0%",
      transform: "translate3d(0, 0, 0)"
    },
    appBar: function appBar(props) {
      return {
        background: props.color.background,
        color: props.color.text,
        zIndex: 3000 // Watch out for Map Moment's SideBar
        // position: "absolute",

      };
    },
    body: {
      padding: 0,
      overflowY: "scroll",
      height: "100%",
      maxWidth: "100%"
    },
    gutter: function gutter(props) {
      return {
        padding: theme.spacing(4)
      };
    },
    headerText: {
      width: "100%"
    }
  };
});
/**
 * The Base `Moment` that all other `Moment`s derive from.
 */

function MomentBase(props) {
  var bodyClassName = props.bodyClassName,
      children = props.children,
      color = props.color,
      index = props.index,
      layout = props.layout,
      subtitle = props.subtitle,
      title = props.title,
      type = props.type;
  var classes = useStyles(props);
  var containerClasses = (0, _utils.classList)(classes.container, 'story-moment', "story-moment-layout-".concat(layout), "story-moment-".concat(type));
  var bodyClasses = (0, _utils.classList)(bodyClassName, "story-moment__content__body "); // NOTE: The second toolbar is to prepend enough gutter space

  var toolBar = _react.default.createElement(_core.Toolbar, {
    className: classes.gutter
  }, _react.default.createElement(_core.Typography, {
    variant: "h4",
    className: classes.headerText
  }, title), _react.default.createElement(_core.Typography, {
    variant: "subtitle1",
    className: classes.headerText
  }, subtitle));

  return _react.default.createElement(_core.Container, {
    justify: "center",
    className: containerClasses,
    id: "story-moment".concat(index),
    key: "story-moment".concat(index)
  }, _react.default.createElement(_core.AppBar, {
    className: classes.appBar
  }, toolBar), _react.default.createElement(_core.Container, {
    className: classes.body
  }, _react.default.createElement("span", {
    style: {
      opacity: 0
    }
  }, toolBar), _react.default.createElement("div", {
    className: bodyClasses
  }, children)));
}

MomentBase.propTypes = {
  /** Determines the body className. */
  bodyClassName: _propTypes.default.string,

  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Determines the structural styling of the `Moment`. */
  layout: _propTypes.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string
};
MomentBase.defaultProps = {
  bodyClassName: "",
  color: {
    background: "gray",
    text: "white"
  },
  layout: "base",
  type: "base"
};
var _default = MomentBase;
exports.default = _default;